import { render, staticRenderFns } from "./DeleteSectionDecisionDialog.vue?vue&type=template&id=8967a310"
import script from "./DeleteSectionDecisionDialog.vue?vue&type=script&lang=js"
export * from "./DeleteSectionDecisionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports